import { toggleScrollLock } from 'common/utils';
import Cookie from 'js-cookie';

const countrySelector = document.getElementById('country-selector');
const countrySelectorStayOnSite = document.getElementById(
  'country-selector-stay'
);
const scrollLockSelector = '#country-selector .Modal__content';
countrySelector && toggleScrollLock(scrollLockSelector, true);

countrySelectorStayOnSite &&
  countrySelectorStayOnSite.addEventListener('click', e => {
    e && e.preventDefault();
    toggleScrollLock(scrollLockSelector, false);
    Cookie.set('stay_on_this_store', true);
    countrySelector.remove();
  });
